<template>
    <div class="container">
        <label class="title">{{title}}</label>
        <label class="subtitle discount" v-if="discount">-${{subtitle}}</label>
        <label class="subtitle" v-else><span>${{subtitle}}</span><del v-if="originalSubtitle">${{originalSubtitle}}</del></label>
    </div>
</template>

<script>
export default {
  props: {
    title: {
    },
    subtitle: {
    },
    originalSubtitle: {
      default: ''
    },
    discount: { default: false }
  }
}
</script>

<style lang="scss" scoped>
    .container {
        display: flex;
        flex-direction: row;
        justify-content: flex-start;
        align-items: center;
        background-color: #fff;
    }
    .title {
        width: 7rem;
        font-size: 0.6rem;
        color: #333;
        margin-left: 0.85rem;
    }
    .subtitle {
        flex: 1;
        margin-left: 1rem;
        margin-right: 0.75rem;
        color: $primaryColor;
        font-size: 0.75rem;
        text-align: right;
    }
    .subtitle.discount{color:#333}
    .subtitle del {
        margin-left: 0.3rem;
        color: #a4aab3;
        font-size: 0.6rem;
    }
</style>
